// "Name (ID:n)" for labels composed on the client from a name and a separate user id
// (REBUILD-525). Returns null for a missing name so callers keep their own placeholder.
export const formatNameWithId = (
  name: string | null | undefined,
  userId: number | null | undefined,
): string | null => {
  if (name == null) return null
  return userId == null ? name : `${name} (ID:${userId})`
}
